var Modal = require("components/utility/AltModal");
var CurrentUser = require("lib/account/CurrentUser");
var ValidatingInput = require("components/utility/ValidatingInput");

require ("support/support_page.scss");

class ContactModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	show() {
		this.refs.modal.show();
	}

	hide() {
		this.refs.modal.hide();
	}

	validateForm() {
		return this.refs.myInput.validate()
	}

	handleSubmit(e){
		$wr.nope(e)
		if (!this.validateForm()) {
			return;
		}
		var callback = $wr.apiHandler(function(response) {
		});
		var userMessage = this.refs.myInput.val();
		var params = {
			contact_message: {
				message: userMessage
			}
		}
		var title = "Message Sent";
		var text = "You have successfully sent us a message. Thank you!";
		CurrentUser.api().postContactMessages(params, callback);
		this.hide();
		window.wrNotifications.triggerDropDownNotification({ title: title,
					text: text, icon: "ok-circle" }, 3000);
	}

	render() {
		return (
			<Modal className= "contactModal" ref="modal"  headerText="Contact Us">
				<form className="contactForm" onSubmit={this.handleSubmit}>
					<ValidatingInput type="textarea" ref="myInput" placeholder="Message goes here..."
					validators={ValidatingInput.Validators.PRESENT} inputClassName="form-control messageArea"/>
					<br />
					<input className="buttonSuccess center-block" type="submit" value="Send" />
				</form>
			</Modal>
		)
	}
};

ContactModal.propTypes = StrictPropTypes({
});

module.exports = ContactModal;



// WEBPACK FOOTER //
// ./modules/components/support/ContactModal.js